import { render } from "./manage-testimonial.vue?vue&type=template&id=5011fb04"
import script from "./manage-testimonial.vue?vue&type=script&lang=js"
export * from "./manage-testimonial.vue?vue&type=script&lang=js"

import "./manage-testimonial.vue?vue&type=style&index=0&id=5011fb04&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__